/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuyRespTopNav_user = {
    readonly " $fragmentRefs": FragmentRefs<"useMeasurementUnit_user" | "BuyRespTopNavFilters_user" | "SbRespRefineTopAppliedFilters_user">;
    readonly " $refType": "BuyRespTopNav_user";
};
export type BuyRespTopNav_user$data = BuyRespTopNav_user;
export type BuyRespTopNav_user$key = {
    readonly " $data"?: BuyRespTopNav_user$data;
    readonly " $fragmentRefs": FragmentRefs<"BuyRespTopNav_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyRespTopNav_user",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useMeasurementUnit_user",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Profile",
          "kind": "LinkedField",
          "name": "profile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "measurementUnit",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyRespTopNavFilters_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespRefineTopAppliedFilters_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '544b89fe6267b5d4d3d63a7208a0f743';
export default node;
